export default __webpack_public_path__ + "static/media/Group 31@2x.814a321f.png";